/**
 * Formats price according to locale and currency
 * @param {number} price - The price to format
 * @param {string} currency - Currency code (e.g., 'USD', 'BRL')
 * @param {string} locale - Locale code (e.g., 'en-US', 'pt-BR')
 * @returns {string} Formatted price string
 */
export const formatPrice = (price, currency = 'USD', locale = 'en-US') => {
  if (price === null || price === undefined) return '';
  
  // For zero values, format without decimals
  if (price === 0) {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price);
  }
  
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(price);
};

/**
 * Gets the appropriate locale for price formatting based on language
 * @param {string} language - Language code from i18n
 * @returns {string} Locale code for price formatting
 */
export const getPriceLocale = (language) => {
  const localeMap = {
    'pt-BR': 'pt-BR',
    'pt': 'pt-BR',
    'en': 'en-US',
    'en-US': 'en-US',
    'es': 'es-419',
    'de': 'de-DE',
  };
  
  return localeMap[language] || 'en-US';
};